import type { ReactElement } from "react";

import type { ApiData } from "../../api/use-api-data.js";
import { NotFoundPage } from "../account/message-pages.js";

/**
 * 読み込み中と、読めなかったとき。
 *
 * <b>404 は「見つからない」画面にする</b>（ほかの画面と同じ。<c>ApiState</c>）。
 * 所属していない・対象が居ない・権限が無いは、サーバが区別せず 404 にしている
 * （存在の有無を出さない。<c>TenantAccessService</c>）ので、画面でも分けない。
 */
export function DataPending({ data, width = "max-w-lg" }: {
    readonly data: Exclude<ApiData<unknown>, { readonly state: "ready" }>;
    /** 外枠の幅。読めた後の画面と揃える。 */
    readonly width?: string;
}): ReactElement {
    if (data.state === "failed" && data.status === 404) {
        return <NotFoundPage />;
    }

    return (
        <div className={`page ${width}`}>
            {data.state === "loading"
                ? <p className="text-slate-500">読み込んでいます…</p>
                : (
                    <div className="alert-danger" role="alert">
                        画面を開けませんでした。お探しのページが見つからないか、操作する権限がありません。
                    </div>
                )}
        </div>
    );
}
